import React, { Component } from "react";
import firebase from "../../firebase";
import { Modal, Button } from "react-bootstrap";

export default class Careers extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false, // Modal visibility state
    };
  }

  componentDidMount() {
    document.title = "Careers";
  }

  // Close modal
  handleClose = () => {
    this.setState({ showModal: false });
  };

  // Show modal
  handleShow = () => {
    this.setState({ showModal: true });
  };

  // Handle form submission
// Handle form submission
handleSubmit = (event) => {
  event.preventDefault(); // Prevent default form submission behavior

  const formData = new FormData(event.target);
  const data = {};

  // Iterate through form data and construct object
  formData.forEach((value, key) => {
    data[key] = value;
  });

  // Reference to Firestore
  const db = firebase.firestore();

  // Check for existing email
  db.collection("careers")
    .where("email", "==", data.email) // Query Firestore for the submitted email
    .get()
    .then((querySnapshot) => {
      if (!querySnapshot.empty) {
        // Email already exists
        this.setState({
          showModal: true,
          modalMessage: "We already have your data. We'll contact you soon!",
        });
      } else {
        // Email does not exist; proceed with adding data
        db.collection("careers")
          .add(data)
          .then(() => {
            console.log("Form data added to Firestore successfully");
            this.setState({
              showModal: true,
              modalMessage:
                "Your message has been sent successfully. Thank you for applying!",
            });
          })
          .catch((error) => {
            console.error("Error adding form data to Firestore: ", error);
            this.setState({
              showModal: true,
              modalMessage: "An error occurred. Please try again later.",
            });
          });
      }
    })
    .catch((error) => {
      console.error("Error checking for existing email: ", error);
      this.setState({
        showModal: true,
        modalMessage: "An error occurred. Please try again later.",
      });
    });
};


  render() {
    const { showModal } = this.state;

    return (
      <>
        <section id="careers" className="contact">
          <div className="container-fluid mt-5" data-aos="fade-up">
            <div className="section-title">
              <h2>Careers</h2>
            </div>

            <div className="row" data-aos="fade-up" data-aos-delay="100">
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-md-12">
                    <div className="info-box1">
                      <h3>Get Started Today</h3>
                      <p align="justify">
                        We believe that every individual, family, and business
                        deserves a chance to achieve their goals. We aid
                        entrepreneurs with information on how to build and
                        stabilize their business or organization. If you are
                        open to new opportunities and looking for a career, we
                        are looking for new team members in all states. If you
                        would like to schedule a confidential meeting to review
                        the details of becoming an entrepreneur, then contact{" "}
                        <b style={{ color: "cadetblue" }}>Finance Frenzy</b>{" "}
                        today!
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-lg-6">
                <div className="info-box1">
                  <div className="col-lg-12 mt-6">
                    <form
                      onSubmit={this.handleSubmit}
               
                      className="php-email-form"
                    >
                      <div className="row">
                        <div className="col-md-12 form-group m-2">
                          <label>
                            <input type="radio" name="options" value="Ms." />
                            &nbsp; Ms. &nbsp;
                          </label>

                          <label>
                            <input type="radio" name="options" value="Mr." />
                            &nbsp; Mr. &nbsp;
                          </label>

                          <label>
                            <input type="radio" name="options" value="Mrs." />
                            &nbsp; Mrs. &nbsp;
                          </label>
                        </div>
                        <div className="col-md-6 form-group">
                          <input
                            type="text"
                            name="Fname"
                            className="form-control"
                            id="firstname"
                            placeholder="First Name"
                            required
                          />
                        </div>
                        <div className="col-md-6 form-group">
                          <input
                            type="text"
                            name="Lname"
                            className="form-control"
                            id="lastname"
                            placeholder="Last Name"
                            required
                          />
                        </div>
                        <div className="col-md-6 form-group mt-3 mt-md-0">
                          <input
                            type="email"
                            className="form-control"
                            name="email"
                            id="email"
                            placeholder="Your Email"
                            required
                          />
                        </div>
                        <div className="col-md-6 form-group mt-3 mt-md-0">
                          <input
                            type="phoneNumber"
                            className="form-control"
                            name="phoneN"
                            id="phoneNumber"
                            placeholder="Your Phone Number"
                            required
                          />
                        </div>
                        <div className="col-md-6 form-group mt-3 mt-md-0">
                          <input
                            type="role"
                            className="form-control"
                            name="roleN"
                            id="role"
                            placeholder="Role apply for"
                            required
                          />
                        </div>
                        <div className="col-md-6 form-group mt-3 mt-md-0">
                          <input
                            type="refer"
                            className="form-control"
                            name="referN"
                            id="refer"
                            placeholder="Your Referral"
                            required
                          />
                        </div>
                      </div>
                      <div className="col-md-12 form-group m-2">
                        <h6>Preferred time to call?</h6>
                        <label>
                          <input
                            type="checkbox"
                            name="morning"
                            value="morning"
                          />
                          &nbsp; Morning &nbsp;
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            name="afternoon"
                            value="afternoon"
                          />
                          &nbsp; Afternoon &nbsp;
                        </label>
                        <label>
                          <input
                            type="checkbox"
                            name="evening"
                            value="evening"
                          />
                          &nbsp; Evening &nbsp;
                        </label>
                      </div>

                      <div className="text-center">
                        <button type="submit">Send Message</button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Success Modal */}
        <Modal show={showModal} onHide={this.handleClose} centered>
  <Modal.Header closeButton>
    <Modal.Title>Notification</Modal.Title>
  </Modal.Header>
  <Modal.Body>{this.state.modalMessage}</Modal.Body>
  <Modal.Footer>
    <Button variant="secondary" onClick={this.handleClose}>
      Close
    </Button>
  </Modal.Footer>
</Modal>

      </>
    );
  }
}
